import httpService from './httpService';
import { IInvestor } from './types/IInvestor';

export const getInvestors = (): Promise<IInvestor[]> => {
  let endpoint = httpService.getEndpointURL('/Investors');
  return httpService.getTyped<IInvestor[]>(endpoint);
};

export const getActiveInvestors = (): Promise<IInvestor[]> => {
  let endpoint = httpService.getEndpointURL('/Investors?activeOnly=true');
  return httpService.getTyped<IInvestor[]>(endpoint);
};

export const getInvestor = (id: number): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Investors/${id}`);
  return httpService.getTyped<any>(endpoint);
};

export const getInvestorAssociations = (id: number): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Investors/${id}/associations`);
  return httpService.getTyped<any>(endpoint);
};
